<template>
  <div class="app-main__inner col-lg-8 col-12 m-auto">
    <TituloComponente
      icono-titulo="fas fa-clipboard-list"
      texto-titulo="Seleccione institución"
      :to-create-action="{name:'NuevaInstitucion'}"
      to-create-text="Nueva institución"
    />
    <div class="tab-content">
      <div class="tab-pane tabs-animation fade show active" id="tab-content-0" role="tabpanel">
        <div class="row">
          <div class="col-lg-12">
            <div class="main-card mb-3 card">
              <div class="card-body">
                <h5 class="card-title">Seleccione la institución con la que desea trabajar</h5>
                <DataList
                  ref="datatable"
                  url="/institucion"
                  :fields="fields"
                  :rowClick="seleccionInstitucion"
                ></DataList>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TituloComponente from "@/components/layouts/TituloComponente";
import axios from 'axios';
import DataList from "@/components/layouts/DataList";
//import Swal from "sweetalert2";
export default {
  name: "ListarInstituciones",
  components: {
    TituloComponente,
    DataList,
  },
  data() {
    return {
      institucion: [],
      fields: [
        {
          name: "razon_social",
          label: "",
          type: "title",
          class: "",
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("setInstitucion", null );
    localStorage.removeItem('institucion');
  },
  methods: {
    seleccionInstitucion(institucion) {
      this.$router.push({ path: "/liquidacion/listar" });
      this.$store.dispatch("setInstitucion", institucion);
      axios.defaults.headers.common['institucionId'] = JSON.parse(localStorage.getItem('institucion')).id;
    },
  },
};
</script>
